import { atom } from "jotai";

export const joinClassroomDialogOpenAtom = atom(false);
export const setJoinClassroomDialogOpenAtom = atom(null, (get, set, value) => {
  set(joinClassroomDialogOpenAtom, value);
});
export const newClassroomAtom = atom("");
export const setNewClassroomAtom = atom(null, (get, set, value) => {
  set(newClassroomAtom, value);
});

export const quickCreateClassroomOpenAtom = atom(false);
export const setQuickCreateClassroomOpenAtom = atom(null, (get, set, value) => {
  set(quickCreateClassroomOpenAtom, value);
});

export const memberLimitAtom = atom(200);